// extracted by mini-css-extract-plugin
export var bubble = "_1y-0";
export var container = "_1y-3";
export var contrastBorder = "_1y-4";
export var greyOut = "_1y-2";
export var initialsWrapper = "_1y-1";
export var large = "_1y-9";
export var medium = "_1y-8";
export var mediumSmall = "_1y-7";
export var mediumSmallMedium = "_1y-c";
export var micro = "_1y-5";
export var small = "_1y-6";
export var tiny = "_1y-b";
export var xTiny = "_1y-a";